import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';

export const FETCH_VARIANT_ATTRIBUTE_REQUEST = 'FETCH_VARIANT_ATTRIBUTE_REQUEST';
export const FETCH_VARIANT_ATTRIBUTE_SUCCESS = 'FETCH_VARIANT_ATTRIBUTE_SUCCESS';
export const FETCH_VARIANT_ATTRIBUTE_ERROR = 'FETCH_VARIANT_ATTRIBUTE_ERROR';

const GET_VARIANT_ATTRIBUTE_DETAIL_REQUEST = 'GET_VARIANT_ATTRIBUTE_DETAIL_REQUEST';
const GET_VARIANT_ATTRIBUTE_DETAIL_SUCCESS = 'GET_VARIANT_ATTRIBUTE_DETAIL_SUCCESS';
const GET_VARIANT_ATTRIBUTE_DETAIL_ERROR = 'GET_VARIANT_ATTRIBUTE_DETAIL_ERROR';

export const CREATE_VARIANT_ATTRIBUTE_REQUEST = 'CREATE_VARIANT_ATTRIBUTE_REQUEST';
export const CREATE_VARIANT_ATTRIBUTE_SUCCESS = 'CREATE_VARIANT_ATTRIBUTE_SUCCESS';
export const CREATE_VARIANT_ATTRIBUTE_ERROR = 'CREATE_VARIANT_ATTRIBUTE_ERROR';

export const UPDATE_VARIANT_ATTRIBUTE_REQUEST = 'UPDATE_VARIANT_ATTRIBUTE_REQUEST';
export const UPDATE_VARIANT_ATTRIBUTE_SUCCESS = 'UPDATE_VARIANT_ATTRIBUTE_SUCCESS';
export const UPDATE_VARIANT_ATTRIBUTE_ERROR = 'UPDATE_VARIANT_ATTRIBUTE_ERROR';

export const DELETE_VARIANT_ATTRIBUTE_REQUEST = 'DELETE_VARIANT_ATTRIBUTE_REQUEST';
export const DELETE_VARIANT_ATTRIBUTE_SUCCESS = 'DELETE_VARIANT_ATTRIBUTE_SUCCESS';
export const DELETE_VARIANT_ATTRIBUTE_ERROR = 'DELETE_VARIANT_ATTRIBUTE_ERROR';

const baseUrl = 'product/ProductVariantAttribute/';

export const fetchVariantAttribute = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_VARIANT_ATTRIBUTE_REQUEST,
        FETCH_VARIANT_ATTRIBUTE_SUCCESS,
        FETCH_VARIANT_ATTRIBUTE_ERROR,
      ],
      callAPI: () => ApiClient.post(baseUrl + 'Search', data),
      payload: { data },
    }),
  );
};

export const getVariantAttributeDetail = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GET_VARIANT_ATTRIBUTE_DETAIL_REQUEST,
        GET_VARIANT_ATTRIBUTE_DETAIL_SUCCESS,
        GET_VARIANT_ATTRIBUTE_DETAIL_ERROR,
      ],
      callAPI: () => ApiClient.get(`${baseUrl}GetDetail/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const createVariantAttribute = (data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [CREATE_VARIANT_ATTRIBUTE_REQUEST, CREATE_VARIANT_ATTRIBUTE_SUCCESS, CREATE_VARIANT_ATTRIBUTE_ERROR],
      callAPI: () => ApiClient.post(baseUrl, data),
      payload: { data, formId },
    }),
  );
};

export const updateVariantAttribute = (id, data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [UPDATE_VARIANT_ATTRIBUTE_REQUEST, UPDATE_VARIANT_ATTRIBUTE_SUCCESS, UPDATE_VARIANT_ATTRIBUTE_ERROR],
      callAPI: () => ApiClient.put(baseUrl + `${id}`, data),
      payload: { data: { ...data, id }, formId },
    }),
  );
};

export const deleteVariantAttribute = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [DELETE_VARIANT_ATTRIBUTE_REQUEST, DELETE_VARIANT_ATTRIBUTE_SUCCESS, DELETE_VARIANT_ATTRIBUTE_ERROR],
      callAPI: () => ApiClient.delete(`${baseUrl}${id}`),
      payload: { data: { id } },
    }),
  );
}

const initialState = {
    payload: {},
    data: {},
    response: {},
    error: {},
    errorMessage: '',
    successMessage: '',
};

export default function reducer(state = initialState, action) {
  const { payload, response, error, successMessage, errorMessage } = action;
  switch (action.type) {
    case FETCH_VARIANT_ATTRIBUTE_REQUEST:
    case GET_VARIANT_ATTRIBUTE_DETAIL_REQUEST:
    case CREATE_VARIANT_ATTRIBUTE_REQUEST:
    case UPDATE_VARIANT_ATTRIBUTE_REQUEST:
    case DELETE_VARIANT_ATTRIBUTE_REQUEST:
      return {
        ...state,
        payload,
        response: {},
        error: {},
        successMessage: '',
        errorMessage: '',
      };

    case FETCH_VARIANT_ATTRIBUTE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          items: response.data.data.items,
          pages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };

    case GET_VARIANT_ATTRIBUTE_DETAIL_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          item: response.data.data,
        },
        response,
        successMessage,
      };
    case CREATE_VARIANT_ATTRIBUTE_SUCCESS:
    case UPDATE_VARIANT_ATTRIBUTE_SUCCESS:
    case DELETE_VARIANT_ATTRIBUTE_SUCCESS:
      return {
        ...state,
        response,
        successMessage,
      };
      
    case FETCH_VARIANT_ATTRIBUTE_ERROR:
    case GET_VARIANT_ATTRIBUTE_DETAIL_ERROR:
    case CREATE_VARIANT_ATTRIBUTE_ERROR:
    case UPDATE_VARIANT_ATTRIBUTE_ERROR:
    case DELETE_VARIANT_ATTRIBUTE_ERROR:
      return {
        ...state,
        payload,
        error,
        errorMessage,
      };
    default:
      return state;
  }
}
